var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiStronglyDisagree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18C36.5 27.941 28.441 36 18.5 36C8.559 36 0.5 27.941 0.5 18C0.5 8.059 8.559 0 18.5 0C28.441 0 36.5 8.059 36.5 18Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.985 28.8791C23.974 28.8351 22.84 24.5001 18.5 24.5001C14.16 24.5001 13.026 28.8351 13.015 28.8791C12.962 29.0921 13.059 29.3101 13.247 29.4231C13.435 29.5351 13.68 29.5091 13.843 29.3631C13.852 29.3551 14.856 28.5001 18.5 28.5001C22.09 28.5001 23.117 29.3301 23.156 29.3631C23.251 29.4531 23.375 29.5001 23.5 29.5001C23.584 29.5001 23.669 29.4791 23.746 29.4361C23.942 29.3241 24.04 29.0971 23.985 28.8791ZM29.5 12.0001C23.946 12.0001 21.698 7.63315 21.605 7.44715C21.358 6.95315 21.558 6.35215 22.052 6.10515C22.545 5.85815 23.144 6.05715 23.392 6.54815C23.467 6.69415 25.213 10.0001 29.5 10.0001C30.053 10.0001 30.5 10.4481 30.5 11.0001C30.5 11.5521 30.053 12.0001 29.5 12.0001ZM7.5 12.0001C6.948 12.0001 6.5 11.5521 6.5 11.0001C6.5 10.4481 6.948 10.0001 7.5 10.0001C12.583 10.0001 13.496 6.88015 13.533 6.74715C13.678 6.21915 14.225 5.89915 14.752 6.03815C15.282 6.17715 15.603 6.71115 15.47 7.24315C15.421 7.43715 14.204 12.0001 7.5 12.0001Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20C13.8807 20 15 18.433 15 16.5C15 14.567 13.8807 13 12.5 13C11.1193 13 10 14.567 10 16.5C10 18.433 11.1193 20 12.5 20Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20C25.8807 20 27 18.433 27 16.5C27 14.567 25.8807 13 24.5 13C23.1193 13 22 14.567 22 16.5C22 18.433 23.1193 20 24.5 20Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiStronglyDisagree);
export default __webpack_public_path__ + "static/media/emoji-strongly-disagree.7c3005712b88a37283a2b14f2ce38cfc.svg";
export { ForwardRef as ReactComponent };